module.exports = __webpack_public_path__ + "img/30m2.3e548516.jpg";